import { useState, useEffect } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import RequiredMark from '../ReqiuredMark';
import PropTypes from 'prop-types';
import { Eye, EyeClose } from '../Svg/Svg';
import { combineClasses as cc } from '../../utils/helpFunctions';

export const ErrorText = ({ text }) => {
    if (text) {
        return <div className="invalid-feedback">{text}</div>;
    }
    return null;
};

export default function CustomInput({
    searchIcon,
    placeholder,
    width,
    onInputChange,
    inputValue,
    labelText,
    labelClass,
    isRequired,
    id,
    errorText,
    className,
    type = 'text',
    name,
    customEl,
    isDisabled = false,
    pattern,
    title,
}) {
    const [error, setError] = useState(errorText || '');

    useEffect(() => {
        setError(errorText);
    }, [errorText]);

    const clearError = () => {
        setError('');
    };

    if (type === 'password') {
        return (
            <div style={{ width: width || '268px' }}>
                {labelText && (
                    <label
                        className={cc('input-label', labelClass)}
                        htmlFor={id}
                    >
                        {labelText}
                        {isRequired && <RequiredMark />}
                    </label>
                )}

                <Input.Password
                    className={className}
                    name={name}
                    id={id}
                    type="password"
                    size="large"
                    placeholder={placeholder}
                    onChange={onInputChange}
                    onFocus={clearError}
                    value={inputValue}
                    status={error && 'error'}
                    pattern={pattern}
                    title={title}
                    iconRender={(visible) =>
                        visible ? (
                            <span style={{ display: 'flex' }}>
                                <EyeClose />
                            </span>
                        ) : (
                            <span style={{ display: 'flex' }}>
                                <Eye />
                            </span>
                        )
                    }
                    autoComplete="username new-password"
                    aria-label="Password"
                />
                {error && <ErrorText text={error[0]} />}
            </div>
        );
    }

    return (
        <div style={{ width: width || '268px' }}>
            {labelText && (
                <label className={cc('input-label', labelClass)} htmlFor={id}>
                    {labelText}
                    {isRequired && <RequiredMark />}
                </label>
            )}

            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <Input
                    className={className}
                    id={id}
                    type={type}
                    size="large"
                    placeholder={placeholder}
                    title={title}
                    prefix={
                        searchIcon ? (
                            <SearchOutlined style={{ color: '#7F7F7F' }} />
                        ) : null
                    }
                    onChange={onInputChange}
                    onFocus={clearError}
                    value={inputValue}
                    status={error && 'error'}
                    name={name}
                    pattern={pattern}
                    disabled={isDisabled}
                />
                {customEl}
            </div>
            {error && <ErrorText text={error[0]} />}
        </div>
    );
}

CustomInput.propTypes = {
    /* Set search icon appearence */
    searchIcon: PropTypes.bool,
    /* Placeholder of the input tag */
    placeholder: PropTypes.string,
    /* Input width */
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /* Function to call on input Change */
    onInputChange: PropTypes.func,
    /* Set value/Text to the input tag */
    inputValue: PropTypes.string,
    /* Set value/Text to the input label */
    labelText: PropTypes.string,
    /* Input value required or not */
    isRequired: PropTypes.bool,
    /* Id of the input tag */
    id: PropTypes.string,
    errorText: PropTypes.array,
};
